import * as KeycloakLib from "keycloak-js";
import * as PubSub from "pubsub-js";

export default class Keycloak {
    private static instance: Keycloak = new Keycloak();
    private kc: any;

    constructor() {
        if (Keycloak.instance === null) {
            this.getInstance();
        }
    }

    public getInstance () {
        return Keycloak.instance;
    }

    public init () {
        this.kc = KeycloakLib({
            clientId: 'bookinfo',
            realm: process.env.REALM,
            responseMode: 'query',
            url: process.env.SSO_URL,
        });

        const token = sessionStorage.getItem('token');
        const refreshToken = sessionStorage.getItem('refreshToken');

        this.kc.init({onLoad: 'login-required', token, refreshToken}).success((authenticated: boolean) => {
            if (authenticated) {
                if (this.kc.token !== undefined && this.kc.refreshToken !== undefined) {
                    window.sessionStorage.setItem('token', this.kc.token);
                    window.sessionStorage.setItem('refreshToken', this.kc.refreshToken);
                    window.sessionStorage.setItem('authenticating', '0');
                    PubSub.publish('AUTH', true);
                }
            } else {
                if (window.sessionStorage.getItem('token') === null) {
                    this.kc.login();
                }
            }
        });
    }

    public login() {
        const authenticating = window.sessionStorage.getItem('authenticating');

        if (authenticating === null) {
            this.kc.login();
            window.sessionStorage.setItem('authenticating', '1');
        }
    }

    public logout() {
        window.sessionStorage.removeItem('authenticating');
        window.sessionStorage.removeItem('token');
        const options = {
            'redirectUri': window.location.origin + '/dashboard'
        };
        this.kc.logout(options);
    }

    public updateToken (seconds: number) {
        this.kc.updateToken(seconds)
            .success((refreshed: any) => {
                if (refreshed) {
                    if (this.kc.token !== undefined && this.kc.refreshToken !== undefined) {
                        window.sessionStorage.setItem('token', this.kc.token);
                        window.sessionStorage.setItem('refreshToken', this.kc.refreshToken);
                        window.sessionStorage.setItem('authenticating', '0');
                        PubSub.publish('AUTH', true);
                    }
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/services/Keycloak.tsx